import { useEffect, useState } from "react";
import "./dynamic-table.css";
import { formatAsEuro } from "../../helpers/helpers";
import { useAppContext } from "../../AppContext";
import { CardMachine } from "../../file.interface";
import { Toggle } from "../toggle/toggle";
import CloseIcon from "../svgs/closeIcon";
import { getKey } from "../increaser-decreaser/counter";

const TerminalsDynamicTable: React.FC = () => {
  //
  const [showModal, setShowModal] = useState<boolean>(false);

  const {
    selectedContractDuration,
    flowCardMachines,
    flowDevices,
    dispatch,
    selectedPOSSolution,
  } = useAppContext();

  const devicesCounter = flowDevices.length;

  const handleCheckboxChange = (index: number) => {
    let newFlow = flowCardMachines.map((cardMachine, i) => {
      if (i === index) {
        return {
          ...cardMachine,
          hasLicence: cardMachine.hasLicence ? false : true,
        };
      } else return cardMachine;
    });
    let counter = 0;
    newFlow = newFlow?.map((terminal: CardMachine, i) => {
      if (terminal.hasLicence) {
        counter++;
        return {
          ...terminal,
          licenceFee:
            selectedPOSSolution?.getTerminalsLicencePrice(
              counter + devicesCounter
            ) ?? 0,
        };
      } else
        return {
          ...terminal,
          hasLicence: false,
          licenceFee: 0,
        };
    });

    dispatch({
      type: "UPDATE_CONTEXT",
      payload: {
        flowCardMachines: newFlow,
      },
    });
  };

  useEffect(() => {
    if (flowCardMachines.length > 0) {
      let counter = 0;
      let newFlow = flowCardMachines?.map((terminal: CardMachine, i) => {
        if (terminal.hasLicence) {
          counter++;
          return {
            ...terminal,
            licenceFee:
              selectedPOSSolution?.getTerminalsLicencePrice(
                counter + devicesCounter
              ) ?? 0,
          };
        } else
          return {
            ...terminal,
            hasLicence: false,
            licenceFee: 0,
          };
      });

      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          flowCardMachines: newFlow,
        },
      });
    }
  }, []);

  const removeItem = (item: CardMachine) => {
    const itemIndex = flowCardMachines.findIndex(
      (_item) => _item.id === item.id
    );
    if (itemIndex !== -1) {
      let alreadyRemoved = false;
      let newFlow = flowCardMachines.filter((_item) => {
        if (_item.id === item.id && !alreadyRemoved) {
          alreadyRemoved = true;
          return false;
        }
        return true;
      });

      let key = getKey(item);

      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          [key]: newFlow,
        },
      });
    }
  };

  return (
    <div className="product-table-main-container">
      {flowCardMachines?.map((cardMachine, i) => {
        let devicePrice: string | number =
          cardMachine.prices[selectedContractDuration];

        let deviceTitle: string = cardMachine.name;

        if (cardMachine?.hasLicence) {
          deviceTitle += " + Licence";
          devicePrice += cardMachine.licenceFee;
        }
        devicePrice = formatAsEuro(devicePrice);

        return (
          <div key={i}>
            <div style={{ margin: "0px 10px -20px 10px", textAlign: "right" }}>
              <CloseIcon
                width={10}
                height={10}
                onClick={() => removeItem(cardMachine)}
              />
            </div>
            <div className="product-row-container">
              <div className="item-table">
                <div className="product-row-img">
                  <img src={cardMachine.imageUrl} alt="" />
                </div>
                <div className="product-row-name">{deviceTitle}</div>
              </div>
              <div className="item-table">
                <Toggle
                  id={i}
                  handleCheckboxChange={() => handleCheckboxChange(i)}
                  isChecked={cardMachine.hasLicence}
                  label="Include licence?"
                  onClickQuestionMark={() => setShowModal(true)}
                />

                <div className="product-row-price">{devicePrice}</div>
              </div>
            </div>
            {i === flowCardMachines.length - 1 &&
              flowCardMachines.length > 1 && (
                <>
                  <div className="app-separator" />
                  <div className="total-align-right">
                    Total:{" "}
                    {formatAsEuro(
                      flowCardMachines.reduce(
                        (total, item) =>
                          total +
                          item.prices[selectedContractDuration] +
                          item.licenceFee,
                        0
                      )
                    )}
                  </div>
                </>
              )}
            {i !== flowCardMachines.length - 1 && (
              <div className="app-separator" />
            )}
          </div>
        );
      })}

      <div className={`app-modal-overlay ${showModal && "modal-active"}`}>
        <div className="modal">
          <div style={{ textAlign: "right" }}>
            <CloseIcon onClick={() => setShowModal(false)} />
          </div>
          <h4 className="title-screen">
            What are the benefits of the license?
          </h4>
          <p>
            When a terminal has a license included, it will not be dependent on
            your POS device and you will be able to perform complex actions
            directly from the card machine.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TerminalsDynamicTable;
